package com.essntl.features.service.domain.model.service

import com.essntl.features.supplier.domain.model.SupplierModel

data class ServiceFilterOptions(
    val searchText: String = "",
    val supplier: SupplierModel? = null,
    val selectedServiceOrderType: ServiceOrderType = ServiceOrderType.Default,
    val selectedTagIds: Set<String> = emptySet(),
    val selectedAreaIds: Set<String> = emptySet(),
    val selectedCategoryIds: Set<String> = emptySet(),
    val excludeCategoryId: String? = null,
) {
    val isFilterApplied
        get() = searchText.isNotEmpty() ||
            supplier != null ||
            selectedTagIds.isNotEmpty() ||
            selectedAreaIds.isNotEmpty() ||
            selectedCategoryIds.isNotEmpty() ||
            !excludeCategoryId.isNullOrEmpty()

}
